<template>
    <div class="w-full md:w-auto">
        <button
            class="btn text-sm is-danger w-full"
            @click="$modal.show('delete-delivery-project')"
        >
            Radera
        </button>
        <adaptive-form-modal
            name="delete-delivery-project"
            primary-button-text="Ta bort leveransprojekt"
            primary-button-class="is-danger"
            title="Ta bort leveransprojekt"
            :redirect-to="redirectRoute"
            method="delete"
            :action="actionRoute"
        >
            <p v-if="hasCriticalItems">
                <span class="font-semibold">Observera:</span>
                Detta projekt innehåller projekteringsdata som kommer att försvinna och inte kunna återskapas.
                <br>
                Är du helt säker på att du vill ta bort leveransprojektet?
            </p>
            <p v-else>Vill du verkligen ta bort leveransprojektet?</p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            deliveryProject: {
                type: Object,
                required: true,
            },
            hasCriticalItems: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            actionRoute() {
                return route('api.delivery-projects.destroy', this.deliveryProject);
            },
            redirectRoute() {
                return route('admin.delivery-projects.index');
            },
        },
    };
</script>
